<template>
  <div :class="loading ? 'cursor-wait' : ''">
    <div v-if="modal" class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center">
        <div class="fixed inset-0 transition-opacity">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <div class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all md:w-auto sm:w-full overflow-y-auto" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
            <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div class="sm:flex sm:items-start">
                    <div class="w-full mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">            
                        <h3 class="text-md leading-6 font-medium text-gray-900" id="modal-headline" v-if="claim">
                            MONTO ACORDADO ({{ claim.code }})
                        </h3>
                        <br>
                        <div class="flex flex-row">
                            <span class="flex items-center bg-grey-lighter rounded rounded-r-none px-3 font-bold text-grey-darker">$</span>
                            <input type="number" v-model="amount" placeholder="Monto" class="text-sm w-3/3 form-input py-2 appearance-none rounded-md focus:border-indigo-600">
                        </div>
                        <div class="flex flex-row" v-if="errors.amount != null">
                            <span class="flex items-center bg-grey-lighter rounded rounded-r-none px-3 font-bold text-grey-darker"></span>
                            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                {{ errors.amount }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
                    <button 
                        @click="closeModal"
                        :disabled="loading"
                        :class="[loading ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-500']"
                        type="button" 
                        class="inline-flex justify-center w-full rounded-md border border-red-300 px-4 py-2 bg-white text-base leading-6 font-medium text-red-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                        <svg
                            class="w-5 h-5 mr-2 -ml-1 text-white-400"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                        >  
                            <path d="M10.185,1.417c-4.741,0-8.583,3.842-8.583,8.583c0,4.74,3.842,8.582,8.583,8.582S18.768,14.74,18.768,10C18.768,5.259,14.926,1.417,10.185,1.417 M10.185,17.68c-4.235,0-7.679-3.445-7.679-7.68c0-4.235,3.444-7.679,7.679-7.679S17.864,5.765,17.864,10C17.864,14.234,14.42,17.68,10.185,17.68 M10.824,10l2.842-2.844c0.178-0.176,0.178-0.46,0-0.637c-0.177-0.178-0.461-0.178-0.637,0l-2.844,2.841L7.341,6.52c-0.176-0.178-0.46-0.178-0.637,0c-0.178,0.176-0.178,0.461,0,0.637L9.546,10l-2.841,2.844c-0.178,0.176-0.178,0.461,0,0.637c0.178,0.178,0.459,0.178,0.637,0l2.844-2.841l2.844,2.841c0.178,0.178,0.459,0.178,0.637,0c0.178-0.176,0.178-0.461,0-0.637L10.824,10z">
                            </path>
                        </svg>
                        Cancelar
                    </button>
                </span>
                
                <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
                    <button 
                        @click="confirm"
                        :disabled="loading"
                        :class="[loading ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-500']"
                        type="button" 
                        class="inline-flex justify-center w-full rounded-md border border-green-300 px-4 py-2 bg-white text-base leading-6 font-medium text-green-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                        <svg
                            class="w-5 h-5 mr-2 -ml-1 text-white-400"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                        >
                            <path d="M10.219,1.688c-4.471,0-8.094,3.623-8.094,8.094s3.623,8.094,8.094,8.094s8.094-3.623,8.094-8.094S14.689,1.688,10.219,1.688 M10.219,17.022c-3.994,0-7.242-3.247-7.242-7.241c0-3.994,3.248-7.242,7.242-7.242c3.994,0,7.241,3.248,7.241,7.242C17.46,13.775,14.213,17.022,10.219,17.022 M15.099,7.03c-0.167-0.167-0.438-0.167-0.604,0.002L9.062,12.48l-2.269-2.277c-0.166-0.167-0.437-0.167-0.603,0c-0.166,0.166-0.168,0.437-0.002,0.603l2.573,2.578c0.079,0.08,0.188,0.125,0.3,0.125s0.222-0.045,0.303-0.125l5.736-5.751C15.268,7.466,15.265,7.196,15.099,7.03">
                            </path>
                        </svg>
                        Aceptar
                    </button>
                </span>
            </div>
        </div>  
    </div>      
  </div>
</template>

<script>
import Vue from 'vue'
import VueAlertify from 'vue-alertify'

Vue.use(VueAlertify)

export default {
  props: {
      claim: {},
      modal: false,
  },

  data() {
    return {
      loading: false,
      amount: null,
      errors: {
        amount: null
      }
    }
  },

  methods: {
    closeModal() {
      this.cleansForm()
      this.cleansErrors()
      this.$emit('closeModal')
    },
    cleansForm() {
      this.amount = null
    },
    cleansErrors() {
        this.errors = {
            amount: null
        }
    },
    validate(){
      this.cleansErrors()
      let valid = true
      if (this.amount == '' || this.amount == null){
        this.errors.amount = "Monto Requerido!"
        valid = false
      }
      return valid
    },
    async confirm() {
      if (this.validate()){
        try {
            this.loading = true
            const data = {
              amount: this.amount
            }

            const resp = await this.$http.patch(`/claims/${this.claim.id}/amount/agreed`, data)
            this.$alertify.success('Monto registrado!') 
            this.loading = false
            this.$emit('refreshData', this.claim.id)
            this.closeModal()
        } catch (error) {
            this.loading = false
            this.$alertify.error('ERROR. No se ha podido registrar el monto acordado!')
        } 
      }
    }
  }
}
</script>

